// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_n3-1";
export var rowFirst = "_n3-3";
export var rowLast = "_n3-5";
export var rowMiddle = "_n3-4";
export var ticketListScroll = "_n3-2";
export var ticketStack = "_n3-0";